import React from 'react';
import { Container, Row } from 'react-bootstrap';

interface FormHeaderProps {
  title: string;
  description?: string | string[];
}

export const FormHeader: React.FC<FormHeaderProps> = ({
  title,
  description
}) => {
  return (
    <Container className="mb-5">
      <Row className="justify-content-md-center mt-5 mb-4">
        <div style={{ textAlign: 'center' }}>
          <h2 className="p-0 m-0 mb-4 text-primary font-weight-bold">{title}</h2>
          {description && (
            typeof description === 'string' 
              ? <p className="p-0 m-0 font-size-medium">{description}</p>
              : description.map((text, index) => (
                  <p key={index} className="p-0 m-0 font-size-medium">{text}</p>
                ))
          )}
        </div>
      </Row>
    </Container>
  );
}; 